import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class MemrIcdCodeService {
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'memr_icd_code/list/?';
  private AddRecord = webapi + 'memr_icd_code/create';
  private EditRecord = webapi + 'memr_icd_code/update';
  private GetRecord = webapi + 'memr_icd_code/byid/';
  private DeleteRecord = webapi + 'memr_icd_code/delete/';
  private AutoComplete = webapi + 'memr_icd_code/autocomplete?';
  private AutoCompletedec = webapi + 'memr_icd_code/autocompleteicddescription?';
  private GetDropDown = webapi + 'memr_icd_code/dropdown?';
  private ReActiveRecord = webapi + 'memr_icd_code/reActive/';
  private DeListRecord = webapi + 'memr_icd_code/deactivated_list/?';


    constructor(
    private http: Http
  ) {
  }
    getAllDeactivatedRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        // console.log(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col);
        return this.http.get(this.DeListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    reActiveRecordService(id: any) {
        return this.http.put(this.ReActiveRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordServiceByAutoComplete(qString: any, col: any): Promise<any> {
    return this.http.get(this.AutoComplete + 'qString=' + qString + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordServiceByAutoCompletedesc(qString: any, col: any): Promise<any> {
    return this.http.get(this.AutoCompletedec + 'qString=' + qString + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getDropDown(currentPage: any, size: any, globalFilter: any): Promise<any> {
    return this.http.get(this.GetDropDown + 'page=' + currentPage + '&size=' + size + '&globalFilter=' + globalFilter)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/memr-icd-code/memr-icd-code.service.ts